'use client';

import { cn } from '@bells/core/lib/utils';
import { forwardRef } from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

const YoutubePlayer = forwardRef<
  HTMLDivElement,
  {
    classNames?: string[];
    youtubeId: string;
    title: string;
    className?: string;
  }
>(({ youtubeId, title, className }, ref) => {
  return (
    <div className={cn('w-full', className)} ref={ref}>
      <LiteYouTubeEmbed id={youtubeId} title={title} />
    </div>
  );
});

YoutubePlayer.displayName = 'YoutubePlayer';
export { YoutubePlayer };
